import { GET_OPERATORI } from '../actions/operatori';

const initialState = {
  loading: false,
  loaded: false,
  result: {},
  error: null,
};

// Get operators list
export const listOperatori = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_OPERATORI}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${GET_OPERATORI}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        error: null,
      };
    case `${GET_OPERATORI}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    default:
      return state;
  }
};
